import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en_lang from "../i18n/locales/en"
import fr_lang from "../i18n/locales/fr"
import aue_lang from "../i18n/locales/aue"
import ch_lang from "../i18n/locales/ch"
import jp_lang from "../i18n/locales/jp"
import no_lang from "../i18n/locales/no"
import ru_lang from "../i18n/locales/ru"

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: en_lang.translation,
        },
        fr: {
            translation: fr_lang.translation,
        },
        aue: {
            translation: aue_lang.translation,
        },
        ch: {
            translation: ch_lang.translation,
        },
        jp: {
            translation: jp_lang.translation,
        },
        no: {
            translation: no_lang.translation,
        },
        ru: {
            translation: ru_lang.translation,
        }
    },
    lng: window.localStorage.getItem('Localelanguage'),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
